import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { SERVICES } from "@/constants/testIds";

/** Seccion de precio promocional dentro de ServiceModal: activarlo muestra
 * precio especial + leyenda + rango de fechas opcional (auto-activacion). */
export default function ServicePricingSection({ form, setForm }) {
  return (
    <div className="border border-border rounded-lg p-3 space-y-3">
      <div className="flex items-center justify-between gap-3">
        <div>
          <Label className="text-sm font-medium text-foreground">Precio promocional</Label>
          <p className="text-xs text-muted-foreground">Muestra el precio regular tachado y el especial destacado.</p>
        </div>
        <Switch checked={form.promo_enabled} onCheckedChange={(v) => setForm((f) => ({ ...f, promo_enabled: v }))} data-testid={SERVICES.modalPromoToggle} />
      </div>
      {form.promo_enabled && (
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Precio promocional (USD)</Label>
              <Input
                type="number" min="0" step="0.01"
                value={form.promo_price}
                onChange={(e) => setForm((f) => ({ ...f, promo_price: e.target.value }))}
                data-testid={SERVICES.modalPromoPriceInput}
              />
            </div>
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Leyenda (opcional)</Label>
              <Input
                value={form.promo_label}
                onChange={(e) => setForm((f) => ({ ...f, promo_label: e.target.value }))}
                placeholder="Ej: Precio especial - agosto"
                data-testid={SERVICES.modalPromoLabelInput}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Desde (opcional)</Label>
              <Input
                type="date"
                value={form.promo_start_date}
                onChange={(e) => setForm((f) => ({ ...f, promo_start_date: e.target.value }))}
                data-testid={SERVICES.modalPromoStartInput}
              />
            </div>
            <div>
              <Label className="text-sm text-muted-foreground mb-1 block">Hasta (opcional)</Label>
              <Input
                type="date"
                value={form.promo_end_date}
                onChange={(e) => setForm((f) => ({ ...f, promo_end_date: e.target.value }))}
                data-testid={SERVICES.modalPromoEndInput}
              />
            </div>
          </div>
          <p className="text-xs text-muted-foreground">
            Si dejas las fechas vacías, la promoción queda activa mientras el interruptor esté encendido.
          </p>
        </div>
      )}
    </div>
  );
}
